module.exports = __webpack_public_path__ + "static/media/adult.ad6a0ffb.png";